<template>
    <div style="height: 98%;">
        <div class="crumbs mcrumb-self">
            <el-breadcrumb separator="-">
                <el-breadcrumb-item>
                    <i class="el-icon-user"></i><span>系统设置</span>
                </el-breadcrumb-item>
                <el-breadcrumb-item><span>用户维护</span></el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div class="container" style="padding: 15px;height: 92%;">
            <div style="height: 94%;">
                <el-table :data="globalUserRelationTableData" ref="globalUserRelationTable" border stripe height="90%" class="table"  @row-click="(row, column) =>clickRowByChecked('globalUserRelationTable', row, column)">
                    <el-table-column type="selection" width="55" align="center"></el-table-column>
                    <el-table-column prop="id" v-if="showColumn"></el-table-column>
                    <el-table-column prop="jungleadId" v-if="showColumn"></el-table-column>
                    <el-table-column prop="originalUserId" v-if="showColumn"></el-table-column>
                    <el-table-column prop="scope" v-if="showColumn"></el-table-column>
                    <el-table-column prop="userName" label="姓名" sortable></el-table-column>
                    <el-table-column prop="userCode" label="用户名" sortable></el-table-column>
                    <el-table-column prop="operate" label="操作" sortable>
                        <template slot-scope="scoped">
                            <div v-if="scoped.row.originalUserId">已关联</div>
                            <div v-else>
                                <el-link v-if="!scoped.row.originalUserId" type="primary" @click="relationUserClickFun(scoped.row)">未关联</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="pwm.page"
                        :page-size="pwm.limit"
                        :page-sizes="pwm.limits"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="pwm.count">
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog title="关联用户" :visible.sync="relationUserOperateDialogVisible" width="55%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <el-form style="width: 98%;">
                    <div style="padding-bottom: 10px;">
                        <div style="display: flex;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>当前集团</label>
                                    </div>
                                    <el-form-item class="ar-form-input">
                                        <el-select v-model="currGroupId" placeholder="请选择" style="width: 100%;" @change="groupSelectChange">
                                            <el-option
                                                v-for="item in allGroupComboData"
                                                :key="item.id"
                                                :label="item.name"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-form>
                <el-form :model="userManageForm" ref="userManageForm" :rules="userFormRule" style="width: 98%;">
                    <el-input v-if="showColumn == true" v-model="userManageForm.id"></el-input>
                    <el-input v-if="showColumn == true" v-model="userManageForm.companyGroupId"></el-input>
                    <div style="padding-bottom: 15px;">
                        <span class="ar-title" style="padding-left: 15px;">用户信息</span>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 姓名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userName">
                                        <el-input v-model="userManageForm.userName" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户名</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userCode">
                                        <el-input v-model="userManageForm.userCode" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>用户类型</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="userType">
                                        <el-select v-model="userManageForm.userType" placeholder="请选择" style="width: 100%;" disabled>
                                            <el-option
                                                v-for="item in this.userTypeData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label><span style="color: red;">*</span> 用户角色</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="roleId">
                                        <el-select v-model="userManageForm.roleId" placeholder="请选择" style="width: 100%;" :disabled="disabledUserRole">
                                            <el-option
                                                v-for="item in roleComboData"
                                                :key="item.id"
                                                :label="item.roleName"
                                                :value="item.id">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团名称</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="groupName">
                                        <el-input v-model="userManageForm.groupName" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>集团编号</label>
                                    </div>
                                    <el-form-item class="ar-form-input" pro="groupNo">
                                        <el-input v-model="userManageForm.groupNo" disabled></el-input>
                                    </el-form-item>
                                </div>
                            </div>
                        </div>
                        <div style="display: flex;padding-top: 10px;">
                            <div class="ar-form-item" style="width: 50%;">
                                <div style="display: flex;">
                                    <div class="ar-form-label">
                                        <label>当前状态</label>
                                    </div>
                                    <el-form-item class="ar-form-input" prop="state">
                                        <el-select v-model="userManageForm.state" placeholder="请选择" style="width: 100%;">
                                            <el-option
                                                v-for="item in statusData"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </div>
                            </div>
                            <div class="ar-form-item" style="width: 50%;"></div>
                        </div>
                    </div>
                    <div style="padding-left: 15px;">
                        <span class="ar-title">关联实体信息</span>
                        <div style="padding-top: 10px;">
                            <el-button plain style="width: 80px;" @click="addRelCompanyClickFun()">添加</el-button>
                            <el-button plain style="width: 80px;" @click="delRelCompanyClickFun()">删除</el-button>
                        </div>
                        <div style="padding-top: 10px;">
                            <el-table :data="userManageForm.companyUsers" border stripe height="250px" class="table" ref="relCompanyTable" @row-click="(row, column) =>clickRowByChecked('relCompanyTable', row, column)">
                                <el-table-column type="selection" width="55" align="center"></el-table-column>
                                <el-table-column prop="id" v-if="showColumn"></el-table-column>
                                <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                                <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveGroupUserDataClickFun('userManageForm')" style="width: 80px;">保存</el-button>
                <el-button @click="relationUserOperateDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>

        <!-- 关联实体信息 - 实体信息显示 -->
        <el-dialog title="公司信息" :visible.sync="showCompanyDataDialogVisible" width="40%" class="dialog" :close-on-click-modal="false">
            <div class="custom-dialog">
                <div style="padding-top: 10px;">
                    <el-table :data="userRelCompanyData" border stripe height="300px" class="table" ref="companyTable" @row-click="(row, column) =>clickRowByChecked('companyTable', row, column)">
                        <el-table-column type="selection" width="55" align="center"></el-table-column>
                        <el-table-column prop="id" v-if="showColumn"></el-table-column>
                        <el-table-column prop="name" label="实体名称" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="taxNumber" label="实体税号" sortable show-overflow-tooltip></el-table-column>
                        <el-table-column prop="state" label="当前状态" :formatter="formatStatus"></el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="saveUserRelCompanyClickFun()" style="width: 80px;">保存</el-button>
                <el-button @click="showCompanyDataDialogVisible = false" style="width: 80px;">返回</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import https, { fetchPost } from '../../../../https.js';
    export default {
        data() {
            return {
                pwm: JSON.parse(JSON.stringify(this.pageobj)),
                showColumn: false,
                currGroupId: '',     //  当前所选集团ID
                allGroupComboData: [],      //  所有集团信息
                allCompanyList: [], //  当前集团下所有实体信息
                roleComboData: [],  //  当前集团下所有角色信息
                globalUserRelationTableData: [],
                relationUserOperateDialogVisible: false,
                disabledUserRole: true,
                userManageForm: {
                    userName: '',
                    userCode: '',
                    password: '',
                    repassword: '',
                    userType: '',
                    roleId: '',
                    groupName: '',
                    groupNo: '',
                    state: '0',
                    companyUsers: []
                },
                userFormRule: {    //  form 校验
                    // userName: [
                    //     { required: true, message: '请输入姓名', trigger: 'blur' },
                    //     { max: 10, message: '姓名不得超过10个字符' }
                    // ],
                    // userCode: [
                    //     { required: true, message: '请输入用户名', trigger: 'blur' },
                    //     { max: 40, message: '用户名不得超过40个字符' }
                    // ],
                    roleId: [
                        { required: true, message: '请选择用户角色', trigger: 'change' }
                    ]
                },
                showCompanyDataDialogVisible: false,
                userRelCompanyData: []
            }
        },
        created: function() {
            this.getGlobalUserRelationData();
        },
        methods: {
             handleSizeChange(val) {
                this.pwm.limit = val;
            },
            handleCurrentChange(val) {
                this.pwm.page = val;
            },
            clickRowByChecked(refTableName, row, column) {
                if(column.property != 'operate') {
                    this.$refs[refTableName].toggleRowSelection(row);
                }
            },
            groupSelectChange(val) {
                this.loadCompanyGroupData();    //  load页面集团信息
                this.getCompanyDataByCurrGroupId(this.currGroupId);  //  加载集团下所有实体信息
            },
            async getAllGroupData() {   //  获取所有集团数据
                await fetchPost('/sys/admin/getAllCompanyGroup', '').then(res => {
                    if(res.data.success) {
                        let groupData = res.data.obj;
                        this.allGroupComboData = groupData;
                        if(groupData && groupData.length > 0) {
                            this.currGroupId = groupData[0].id;
                        }
                    } else {
                        this.$message.error('获取所有集团信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取所有集团信息失败：' + error);   
                });
            },
            async getCompanyDataByCurrGroupId(groupId) { //  用户勾选关联公司：company data
                await fetchPost('/sys/admin/getCompanyListByGroup', groupId).then(res => {
                    if(res.data.success) {
                        this.allCompanyList = res.data.obj;
                    } else {res.data.data;
                        this.$message.error('获取当前集团下所有实体信息失败：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('获取当前集团下所有实体信息失败：' + error);
                });
            },
             async getRoleListByGroupId(groupId, userType) { //  获取当前集团下的所有用户角色数据
                await fetchPost('/sys/admin/getRoleListByCompanyGroup', groupId).then(res => {
                    if(res.data.success) {
                        let roleComboData = res.data.obj;
                        if(userType == '1') {   //  集团管理员
                            roleComboData = roleComboData.filter(roleObj => {
                                return roleObj.roleName == '集团管理员';
                            });
                        } else {    //  集团用户
                            roleComboData = roleComboData.filter(roleObj => {
                                return roleObj.roleName != '集团管理员';
                            });
                        }
                        this.roleComboData = roleComboData;
                    } else {
                        this.$message.error('加载当前集团下用户角色信息错误：' + res.data.message);
                    }
                }, error => {
                    this.$message.error('加载当前集团下用户角色信息错误：' + error);
                });
            },
            getGlobalUserRelationData() {
                fetchPost('/sso/user/getGlobalUserRelationList', this.pwm).then(res => {
                    this.globalUserRelationTableData = res.data.data;
                    this.pwm.count = res.data.count;
                }, error => {
                    this.$message.error('加载用户维护数据失败：' + error);
                });
            },
            relationUserClickFun(row) {
                this.userManageForm.companyUsers = [];
                if(row.scope == '1') {
                    this.disabledUserRole = true;
                } else {
                    this.disabledUserRole = false;
                }

                this.userManageForm.userType = row.scope;
                this.userManageForm.userCode = row.userCode;
                this.userManageForm.userName = row.userName;
                this.userManageForm.jungleadId = row.jungleadId;

                this.getAllGroupData().then(() => {
                    this.loadCompanyGroupData();    //  load页面集团信息
                    this.getCompanyDataByCurrGroupId(this.currGroupId);  //  加载集团下所有实体信息
                    this.getRoleListByGroupId(this.currGroupId, row.scope).then(() => {    //  加载集团下所有角色数据
                        if(this.roleComboData && this.roleComboData.length > 0) {
                            this.userManageForm.roleId = this.roleComboData[0].id;
                        }
                    });
                    this.relationUserOperateDialogVisible = true;
                });
            },
            loadCompanyGroupData() {
                let currGroupData = this.allGroupComboData.filter(group => {
                    return group.id == this.currGroupId;
                });
                if(currGroupData) {
                    this.userManageForm.companyGroupId = currGroupData[0].id;
                    this.userManageForm.groupName = currGroupData[0].name;
                    this.userManageForm.groupNo = currGroupData[0].code;
                }
            },
            addRelCompanyClickFun() {   //  新增用户关联公司信息
                this.showCompanyDataDialogVisible = true;
                //  过滤掉用户已关联的实体信息
                this.userRelCompanyData = this.allCompanyList.filter(company => {
                    let checkIdList = this.userManageForm.companyUsers.map(data => data.id);
                    return !checkIdList .includes(company.id)
                })
            },
            delRelCompanyClickFun() {   //   删除用户关联公司信息
                let checkRows = this.$refs.relCompanyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要删除关联的公司信息！');
                    return;
                }

                //  过滤掉用户已关联的实体信息
                this.userRelCompanyData = this.allCompanyList.filter(company => {
                    let checkIdList = this.userManageForm.companyUsers.map(data => data.id);
                    return !checkIdList .includes(company.id)
                })

                let relCompanyData = this.userManageForm.companyUsers;
                this.userManageForm.companyUsers = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                this.allCompanyList = this.userRelCompanyData.concat(checkRows);
            },
            saveUserRelCompanyClickFun() {  //  保存用户勾选的公司信息
                let checkRows = this.$refs.companyTable.selection;
                if(!checkRows || checkRows.length == 0) {
                    this.$message.warning('请选择需要关联的公司信息！');
                    return;
                }
                let relCompanyData = this.userRelCompanyData;
                this.allCompanyList = relCompanyData.filter(company => {
                    let checkIdList = checkRows.map(row => row.id);
                    return !checkIdList.includes(company.id);
                });

                this.userManageForm.companyUsers = this.userManageForm.companyUsers.concat(checkRows);
                this.showCompanyDataDialogVisible = false;
            },
            saveGroupUserDataClickFun(formName) {   //  save / update
                this.$refs[formName].validate((valid) => {
                    if(!valid) {
                        return false;
                    }
                    let userData = this.userManageForm;
                    let companyIdList = [];
                    let userCheckCompanyData = userData.companyUsers;
                    if(!userCheckCompanyData || userCheckCompanyData.length == 0) {
                        this.$message.warning('请选择用户所关联的实体信息！');
                        return;
                    }
                    userCheckCompanyData.forEach(company => {
                        companyIdList.push(company.id);
                    });
                    userData.companyIds = companyIdList.join(',');
                    let companyUsers = JSON.parse(JSON.stringify(userData.companyUsers));
                    delete userData.companyUsers;
                    
                    let jungleadId = userData.jungleadId;
                    delete userData.jungleadId;
                    let params = { userData: userData, jungleadId: jungleadId };
                    fetchPost('/sso/user/addUser', params).then(res => {
                        if(res.data.success) {
                            this.$message.success('保存用户信息成功！');
                            this.relationUserOperateDialogVisible = false;   //  关闭dialog
                            //  reload relation user table
                            this.getGlobalUserRelationData();
                        } else {
                            this.$message.error('保存用户信息失败：' + res.data.message);   
                            this.userManageForm.companyUsers = companyUsers;
                        }
                    }, error => {
                        this.$message.error('保存用户信息失败：' + error);
                    });
                })
            }
        }
    }
</script>

<style scoped>
    .table {
        width: 100%;
        font-size: 14px;
    }
    .el-dialog {
        margin: 0 auto !important;
    }
    .el-dialog__header {
        padding: 0 !important;
    }
    .el-dialog__wrapper {
        display: flex ;
        align-items: center ;
    }
</style>